import instance from "lib/axiosInterceptor";
import {
  MeetBootstrapRequest,
  MeetBootstrapResponse,
  MeetStartActivityRequest,
  MeetJoinActivityRequest,
  MeetActivityResponse,
} from "types/meet-addon";
import {
  MeetHealthResponse,
  MeetHostEventsResponse,
  MeetParticipantSnapshotResponse,
  MeetParticipantTimelineParams,
  MeetParticipantTimelineResponse,
  MeetSessionSummaryResponse,
} from "interfaces/meet-addon.interface";

const BASE_PATH = "/integrations/google-meet-addon";

export async function bootstrapMeetAddonService(
  payload: MeetBootstrapRequest,
): Promise<MeetBootstrapResponse> {
  const response = await instance.post<MeetBootstrapResponse>(
    `${BASE_PATH}/bootstrap`,
    payload,
  );

  return response.data;
}

export async function startMeetActivityService(
  payload: MeetStartActivityRequest,
): Promise<MeetActivityResponse> {
  const response = await instance.post<MeetActivityResponse>(
    `${BASE_PATH}/activity/start`,
    payload,
  );

  return response.data;
}

export async function joinMeetActivityService(
  payload: MeetJoinActivityRequest,
): Promise<MeetActivityResponse> {
  const response = await instance.post<MeetActivityResponse>(
    `${BASE_PATH}/activity/join`,
    payload,
  );

  return response.data;
}

export async function getMeetParticipantsSnapshotService(
  conferenceId: string,
): Promise<MeetParticipantSnapshotResponse> {
  const response = await instance.get<MeetParticipantSnapshotResponse>(
    `${BASE_PATH}/meetings/${conferenceId}/participants/snapshot`,
  );

  return response.data;
}

export async function getMeetParticipantsTimelineService(
  conferenceId: string,
  params?: MeetParticipantTimelineParams,
): Promise<MeetParticipantTimelineResponse> {
  const response = await instance.get<MeetParticipantTimelineResponse>(
    `${BASE_PATH}/meetings/${conferenceId}/participants/timeline`,
    { params },
  );

  return response.data;
}

export async function getMeetSessionSummaryService(
  conferenceId: string,
): Promise<MeetSessionSummaryResponse> {
  const response = await instance.get<MeetSessionSummaryResponse>(
    `${BASE_PATH}/meetings/${conferenceId}/session-summary`,
  );

  return response.data;
}

export async function getMeetAddonHealthService(): Promise<MeetHealthResponse> {
  const response = await instance.get<MeetHealthResponse>(`${BASE_PATH}/health`);

  return response.data;
}

export async function getMeetHostEventsService(): Promise<MeetHostEventsResponse> {
  const response = await instance.get<MeetHostEventsResponse>(`${BASE_PATH}/host/events`);
  return response.data;
}
